import { render, staticRenderFns } from "./BaseEmptyTable.vue?vue&type=template&id=ac0e7678&"
import script from "./BaseEmptyTable.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports